/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Subscription_Rights_Quota_MonthInputs */

const fr_admin_subscription_rights_quota_month = /** @type {(inputs: Admin_Subscription_Rights_Quota_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cours par mois (Crossfit ou Hyrox)`)
};

/**

* @param {Admin_Subscription_Rights_Quota_MonthInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const admin_subscription_rights_quota_month = /** @type {((inputs?: Admin_Subscription_Rights_Quota_MonthInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Subscription_Rights_Quota_MonthInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_admin_subscription_rights_quota_month(inputs)
});